import Button from "devextreme-react/button";
import { useState } from "react";
import { Buffer } from 'buffer';
import { showErrorMessage } from "../../../../utils/messages";
import { MaterialCostReportParams } from "../types/MaterialCostReportParams";
import { apiPrintMaterialCost } from "../api/print-material-cost";
import { LoadPagePanel } from "../../../../components";

export default function MaterialCostPrintButton(params: MaterialCostReportParams) {
	let [loading, setLoading] = useState(false);

	return (
		<>
			<Button
				text="Print"
				icon="Inscyth-Print"
				onClick={() => {
					setLoading(true);

					apiPrintMaterialCost(params)
						.then((result) => {
							if (result.isSuccess) {
								const file = new Blob(
									[Buffer.from(result.data, "base64")],
									{ type: 'application/pdf' });

								const fileURL = URL.createObjectURL(file);
								window.open(fileURL);
							}
							else {
								showErrorMessage(result.errorMessage!);
							}
						})
						.catch((reason) => {
							showErrorMessage(reason);
						})
						.finally(() => { setLoading(false); });
				}}>
			</Button>
			<LoadPagePanel visible={loading} />
		</>
	)
}
